import { Card, CardContent, Box, Skeleton } from "@mui/material";

export default function DashboardCardSkeleton() {
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column", backgroundColor: "#fafafa" }}>
      {/* Image skeleton */}
      <Skeleton variant="rectangular" width="100%" height={120} />
      
      {/* Card content skeleton */}
      <CardContent sx={{ flexGrow: 1, textAlign: "center", p: "16px" }}>
        {/* Title skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Skeleton variant="text" width="80%" height={25} />
        </Box>
        {/* Description skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Skeleton variant="text" width="60%" height={15} />
        </Box>
      </CardContent>
    </Card>
  );
}


// import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";

// export default function DashboardCardSkeleton() {
//   return (
//     <Card sx={{ height: "100%", display: "flex", flexDirection: "column", backgroundColor: "#fafafa !important" }}>
//       <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", pt: "10px" }}>
//         <Skeleton variant="rectangular" width={80} height={80} />
//       </Box>
//       <CardContent sx={{ textAlign: "center", p: "0px" }}>
//         <Typography
//           variant="h6"
//           component="div"
//           sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
//         >
//           <Skeleton width="80%" />
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           <Skeleton width="60%" />
//         </Typography>
//       </CardContent>
//     </Card>
//   );
// }
